import { fetchData } from '@umu/umu-fetch';
import { IListResponse, IUserInfo } from '@umu/umu-types';
import API from '../../path';

export interface IDepartmentMember {
    department_id: number;
    member_id: number;
    name: string;
    number: string;
    on_job_status: string;
    role: number;
    role_type: string;
    user_info: IUserInfo;
}

export const getDepartmentAllMembers = (department_id: string): Promise<IListResponse<IDepartmentMember>> => {
    return fetchData(API.GET_DEPARTMENT_MEMBERS, {
        page: 1,
        size: 1500,
        department_id,
        allow_manager: 1,
    });
};

export interface IGroupMember {
    avatar: string;
    umu_id: string;
    user_name: string;
}

export const getGroupAllMembers = (enterprise_group_id: string): Promise<IListResponse<IGroupMember>> => {
    return fetchData(API.GET_GROUP_MEMBERS, {
        page: 1,
        sort: 1,
        size: 1500,
        is_manager: 0,
        enterprise_group_id,
    });
};

export interface IClassMember {
    avatar: string;
    umu_id: string;
    user_name: string;
}

export const getClassAllMembers = (class_id: string): Promise<IListResponse<IClassMember>> => {
    return fetchData(API.GET_CLASS_MEMBERS, {
        page: 1,
        size: 1500,
        class_id,
    });
};
